import {ApDynformsConfigFieldset}              from '../../../../ap-dynforms/config/ap-dynforms-config-fieldset';
import {ApDynformsConfigTextbox}               from '../../../../ap-dynforms/config/ap-dynforms-config-textbox';
import {nameOf}                                from '../../../../ap-core/utils/ap-name-of';
import {
  IPpProductAvailableCrops,
  IPpProductSelectedDetails,
  IPpProductWizardDetailsData,
  IPpProductWizardDetailsResponsiveData
}                                              from '../pp-product-wizard.types';
import {ApDynformsConfigComboBox}              from '../../../../ap-dynforms/config/ap-dynforms-config-combobox';
import {ApDynformsValidator}                   from '../../../../ap-dynforms/ap-dynforms-validator';
import {Validators}                            from '@angular/forms';
import {ApDynformsConfigDatepicker}            from '../../../../ap-dynforms/config/ap-dynforms-config-datepicker';
import {ApDynformsConfigPlaceholder}           from '../../../../ap-dynforms/config/ap-dynforms-config-placeholder';
import {ApDynformsConfigCheckbox}              from '../../../../ap-dynforms/config/ap-dynforms-config-checkbox';
import {LoginStore}                            from '../../../../stores/login/login.store';
import {WorkTypesStore}                        from '../../../../stores/base-data/worrktypes.store';
import {ApDynformsConfigButton}                from '../../../../ap-dynforms/config/ap-dynforms-config-button';
import {EventEmitter, Injectable, TemplateRef} from '@angular/core';
import {ApDynformsConfigTemplate}              from '../../../../ap-dynforms/config/ap-dynforms-config-template';
import {ApDynformsConfigNumerictextbox}        from '../../../../ap-dynforms/config/ap-dynforms-config-numerictextbox';
import {map}                                   from 'rxjs/operators';
import {EffectiveRangesStore}                  from '../../../../stores/common/effective-ranges.store';
import {ApDynGridPropertyColumnConfig}         from '../../../../ap-dyngrids/config/ap-dyn-grid-property-column-config';
import {ApDynGridButtonColumnConfig}           from '../../../../ap-dyngrids/config/ap-dyn-grid-button-column-config';
import {GetRoundNumericPipe}                   from '../../../../ap-utils';
import {SettingsStore}                         from '../../../../stores/base-data/settings.store';
import {ApDynGridColumnConfigBase}             from '../../../../ap-dyngrids/config/ap-dyn-grid-column-config-base';
import {ApTranslationService}                  from '../../../../ap-utils/service/ap-translation.service';
import {ApDynformsConfigMultiSelect}           from '../../../../ap-dynforms/config/ap-dynforms-config-multiselect';
import {ApRoleTypeService}                     from '../../../../services/common/ap-role-type.service';
import {CountryStore}                          from '../../../../stores/common/country.store';
import {UnitsStore}                            from '../../../../stores/common/units.store';
import {ApDynformsConfigBase}                  from '../../../../ap-dynforms/config/ap-dynforms-config-base';
import ICountry = Data.Common.ICountry;
import IWorktypes = Data.BaseData.IWorktypes;
import IUnit = Data.Common.IUnit;

/**
 * PP-product wizard details-tab ui logic provider
 */
@Injectable()
export class PpProductWizardDetailsUiProvider {
  constructor(private unitsStore: UnitsStore,
              private loginStore: LoginStore,
              private countryStore: CountryStore,
              private settingsStore: SettingsStore,
              private effectiveRangesStore: EffectiveRangesStore,
              private workTypesStore: WorkTypesStore,
              private translationService: ApTranslationService,
              private roundNumericPipe: GetRoundNumericPipe) {
  }

  /**
   * Method to retrieve fieldSets for the product details tab
   */
  public createFieldset(responsiveData: IPpProductWizardDetailsResponsiveData,
                        addDetailsCallback: EventEmitter<any>,
                        ppProductSelectedDetailsTemplate: TemplateRef<any>,
                        ppProductAvailableCropsTemplate: TemplateRef<any>): ApDynformsConfigFieldset[] {
    const result: ApDynformsConfigFieldset[] = [];

    result.Add(this.generateGeneraConfigFiledSet(responsiveData));

    result.Add(new ApDynformsConfigFieldset({
        key: 'Agronomy',
        legend: 'Global__Agronomy',
        config: [
          new ApDynformsConfigComboBox({
            key: nameOf<IPpProductWizardDetailsData>('WorkType'),
            label: 'Docu_Ini__WorkType',
            options: this.workTypesStore.WorkTypes$.pipe(
              map(x => x.filter(z => z.Category_Text === 'Worktype_Category_PlantProtection'))
            ),
            sort: 1,
            valueField: nameOf<IWorktypes>('Id'),
            textField: nameOf<IWorktypes>('Description'),
            translate: true,
            validators: [
              new ApDynformsValidator({validator: Validators.required, errorKey: 'Settings__Msg_Vali_Value_Required'})
            ]
          }),
          new ApDynformsConfigComboBox({
            key: nameOf<IPpProductWizardDetailsData>('Unit'),
            label: 'Settings__Lbl_Menu_Unit',
            sort: 1,
            options: responsiveData.AvailableUnits$,
            disabled$: responsiveData.UnitDisabled$,
            valueField: nameOf<IUnit>('Id'),
            textField: nameOf<IUnit>('Key'),
            translate: true,
            validators: [
              new ApDynformsValidator({validator: Validators.required, errorKey: 'Settings__Msg_Vali_Value_Required'})
            ]
          }),
        ]
      }
    ));

    result.Add(new ApDynformsConfigFieldset({
        key: 'Agronomy2',
        legend: 'Agronomy2',
        hideLegend: true,
        classList: 'ap-field-set-no-legend-line',
        columns: 1,
        useMaxWidth: true,
        config: [
          new ApDynformsConfigTemplate({
            key: 'AvailableCrops',
            value: ppProductAvailableCropsTemplate
          })
        ]
      }
    ));

    result.Add(new ApDynformsConfigFieldset({
        key: 'Agronomy3',
        legend: 'Agronomy3',
        hideLegend: true,
        classList: 'ap-field-set-no-legend-line',
        config: [
          new ApDynformsConfigNumerictextbox({
            key: nameOf<IPpProductWizardDetailsData>('GrowStageMin'),
            label: `Global__EC_Min`,
            min: 0,
            max: responsiveData.PreselectedGrowStageMax$,
            decimals: 0,
            format: 'n0',
            validators: [
              new ApDynformsValidator({validator: Validators.required, errorKey: 'Settings__Msg_Vali_Value_Required'})
            ]
          }),
          new ApDynformsConfigNumerictextbox({
            key: nameOf<IPpProductWizardDetailsData>('GrowStageMax'),
            label: `Global__EC_Max`,
            min: responsiveData.PreselectedGrowStageMin$,
            max: 99,
            decimals: 0,
            format: 'n0',
            validators: [
              new ApDynformsValidator({validator: Validators.required, errorKey: 'Settings__Msg_Vali_Value_Required'})
            ]
          }),
          new ApDynformsConfigNumerictextbox({
            key: nameOf<IPpProductWizardDetailsData>('MaxRate'),
            label$: responsiveData.PreselectedUnit$.pipe(map(d => {
              const baseHeader = this.translationService.translate('MaxAllowed');
              return d?.length > 0 ? `${baseHeader} [${d}]` : baseHeader;
            })),
            min: 0,
            max: 9999,
            validators: [
              new ApDynformsValidator({validator: Validators.required, errorKey: 'Settings__Msg_Vali_Value_Required'})
            ]
          }),
          new ApDynformsConfigMultiSelect({
            key: nameOf<IPpProductWizardDetailsData>('EffectiveRanges'),
            label: 'Effective_Range',
            options: this.effectiveRangesStore.EffectiveRanges$,
            sort: 1,
            valueField: nameOf<IUnit>('Id'),
            textField: nameOf<IUnit>('Key'),
            translate: true,
            validators: [
              new ApDynformsValidator({validator: Validators.required, errorKey: 'Settings__Msg_Vali_Value_Required'})
            ]
          }),
          new ApDynformsConfigTextbox({
            key: nameOf<IPpProductWizardDetailsData>('Indicator'),
            label: 'Base_Pages_Rax__IndicationNote'
          })
        ]
      }
    ));

    result.Add(new ApDynformsConfigFieldset({
      key: 'AddProductDetails',
      legend: 'AddProductDetails',
      hideLegend: true,
      classList: 'ap-field-set-no-legend-line',
      columns: 3,
      config: [
        new ApDynformsConfigPlaceholder(),
        new ApDynformsConfigButton({
          key: 'addProductDetailsButtonKey',
          value: 'Global__TakeOver',
          callback: addDetailsCallback,
          disabledButton$: responsiveData?.AddDetailsButtonDisabled$
        }),
        new ApDynformsConfigPlaceholder()
      ]
    }));
    result.Add(new ApDynformsConfigFieldset({
      key: 'Result',
      legend: 'Global__Result',
      columns: 1,
      useMaxWidth: true,
      config: [
        new ApDynformsConfigTemplate({
          key: 'SelectedDetails',
          value: ppProductSelectedDetailsTemplate
        })
      ]
    }));
    return result;
  }

  /**
   * Method to retrieve columns for the crop-selection grid (embedded in a template)
   */
  public getAvailableCropsColumns(): ApDynGridColumnConfigBase[] {
    return [
      new ApDynGridPropertyColumnConfig({
        title: 'Global__Crop',
        field: nameOf<IPpProductAvailableCrops>('CropTypeName')
      })
    ];
  }

  /**
   * Method to retrieve columns for the product details grid (embedded in a template)
   */
  public getProductDetailsColumns(deleteProductDetailsCallback: EventEmitter<any>, unitId: number | undefined): ApDynGridColumnConfigBase[] {
    return [
      new ApDynGridPropertyColumnConfig({
        title: 'Global__Crop',
        field: nameOf<IPpProductSelectedDetails>('CropTypeNames'),
        width: 350
      }),
      new ApDynGridPropertyColumnConfig({
        title: 'Global__EC_Min',
        field: nameOf<IPpProductSelectedDetails>('GrowStageMin'),
        cssClass: 'right',
        width: 50
      }),
      new ApDynGridPropertyColumnConfig({
        title: 'Global__EC_Max',
        field: nameOf<IPpProductSelectedDetails>('GrowStageMax'),
        cssClass: 'right',
        width: 50
      }),
      new ApDynGridPropertyColumnConfig({
        title: 'MaxRateShort',
        field: nameOf<IPpProductSelectedDetails>('MaxRate'),
        unit: this.translationService.translate(this.unitsStore.getUnitWithUnit(unitId)?.Key),
        width: 100,
        cssClass: 'right',
        pipes: [{
          pipe: this.roundNumericPipe,
          args: [this.settingsStore.FirstSetting?.DigitsAfterDecimalPoint]
        }]
      }),
      new ApDynGridPropertyColumnConfig({
        title: 'Effective_Range',
        field: nameOf<IPpProductSelectedDetails>('EffectiveRanges'),
        width: 100
      }),
      new ApDynGridPropertyColumnConfig({
        title: 'Base_Pages_Rax__IndicationNote',
        field: nameOf<IPpProductSelectedDetails>('Indicator'),
        width: 150
      }),
      new ApDynGridButtonColumnConfig({
        tooltip: 'Global__Delete',
        callback: deleteProductDetailsCallback,
        isStandardIcon: true,
        standardIcon: nameOf<IPpProductSelectedDetails>('ButtonIconName')
      })
    ];
  }

  private generateGeneraConfigFiledSet(responsiveData: IPpProductWizardDetailsResponsiveData): ApDynformsConfigFieldset {
    const inputs: ApDynformsConfigBase<any>[] = [
      new ApDynformsConfigTextbox({
        key: nameOf<IPpProductWizardDetailsData>('ProductName'), // 'Count_Fields',
        label: 'Global__Product',
        validators: [
          new ApDynformsValidator({validator: Validators.required, errorKey: 'Settings__Msg_Vali_Value_Required'})
        ]
      }),
      new ApDynformsConfigTextbox({
        key: nameOf<IPpProductWizardDetailsData>('Note'),
        label: 'Global__Note',
      }),
      new ApDynformsConfigDatepicker({
        key: nameOf<IPpProductWizardDetailsData>('PermissionStart'),
        label: 'Docu_Ini__StartDate',
        formErrors: ['AgriConnect_Error_MinMax'],
        validators: [
          new ApDynformsValidator({validator: Validators.required, errorKey: 'Settings__Msg_Vali_Value_Required'})
        ]
      }),
      new ApDynformsConfigDatepicker({
        key: nameOf<IPpProductWizardDetailsData>('PermissionEnd'),
        label: 'Docu_Ini__EndDate',
        minDate: responsiveData.MinPermissionEnd$,
        formErrors: ['AgriConnect_Error_MinMax'],
        validators: [
          new ApDynformsValidator({validator: Validators.required, errorKey: 'Settings__Msg_Vali_Value_Required'})
        ]
      }),
      new ApDynformsConfigDatepicker({
        key: nameOf<IPpProductWizardDetailsData>('UseByDate'),
        label: 'Global__Expire_Date',
        minDate: responsiveData.MinUseByDate$,
        formErrors: ['AgriConnect_Error_MinMax'],
        validators: [
          new ApDynformsValidator({validator: Validators.required, errorKey: 'Settings__Msg_Vali_Value_Required'})
        ]
      }),
    ];
    if (ApRoleTypeService.hasAgriconRole(this.loginStore.User)) {
      inputs.push(new ApDynformsConfigComboBox({
        key: nameOf<IPpProductWizardDetailsData>('Country'),
        label: 'Global__Country',
        options: this.countryStore.Countries$,
        disabled: responsiveData.CountryDisabled$.getValue(),
        disabled$: responsiveData.CountryDisabled$.asObservable(),
        valueField: nameOf<ICountry>('Id'),
        textField: nameOf<ICountry>('Id'),
        validators: [
          new ApDynformsValidator({validator: Validators.required, errorKey: 'Settings__Msg_Vali_Value_Required'})
        ]
      }));
      inputs.push(new ApDynformsConfigPlaceholder());
      inputs.push(new ApDynformsConfigCheckbox({
        label: 'Country_wide_available',
        key: nameOf<IPpProductWizardDetailsData>('IsCountryWide')
      }));
    }
    return new ApDynformsConfigFieldset({
      key: 'General',
      legend: 'Global__General_Information',
      config: inputs
    });
  }
}
